const ENUM = {
    TIPO_BEM: {
        BENFEITORIA: 1,
        EQUIPAMENTOS_MOVEIS: 2,
        EQUIPAMENTOS_ESTACIONARIOS: 3,
        PRODUTOS_AGROPECUARIOS: 4
    },
    STATUS_COTACAO: {
        SIMULACAO_INICIADA: 1,
        PROPOSTA_INICIADA: 2,
        PROPOSTA_FINALIZADA: 3
    },
    TIPO_COTACAO: {
        NEG_ESPECIAL: 1
    },
    VIGENCIA: {
        PADRAO: 'Padrão',
        SELETIVA: 'Seletiva'
    },
    TIPOS_COBERTURA: {
        BASICA: 1,
        ADICIONAL: 2
    },
    TIPO_CONTA: {
        CONTA_POUPANCA: 'CONTA_POUPANCA',
        CONTA_CORRENTE: 'CONTA_CORRENTE'
    },
    VALIDADE_COTACAO: {
        VIGENTE: 'Vigente',
        EXPIRADA: 'Expirada',
        ENVIADA: 'Enviada'
    },
    TAB_PANELS: {
        SIMULACOES: 0,
        CONTRATACAO: 1
    },
    RESPOSTA_CONTEUDO: '9999',
    ID_BANCO_DO_BRASIL: 1
};

export default ENUM;
